import * as types from './mutations_type.js'

//i18n
import { app } from '../main.js'

//mutations
export const mutations = {
  [types.SET_LANG] (state, payload) {
    // app.$i18n.locale = payload
    // state.customLang = payload
    window.location.reload()
  },
  [types.SET_LANG_LIST] (state, payload) {
    state.langList = payload
  },
  [types.SET_INIT_LANG] (state, payload) {
    state.defaultLang = payload.default
    state.customLang = payload.custom
  },
  [types.SET_LOADINGSHOW] (state, payload){
    state.isLoadingShow = payload
  }
}